import type { DiagramProps } from '@/lib/scad-feature-types';
import { D } from './DiagramStyles';

export function HullDiagram(_props: DiagramProps) {
  // Scattered points / small shapes
  const shapes = [
    { x: 60,  y: 90  },
    { x: 90,  y: 45  },
    { x: 130, y: 80  },
    { x: 110, y: 110 },
    { x: 75,  y: 115 },
    { x: 50,  y: 65  },
  ];

  // Convex hull (manually specified for these points)
  const hull = "50,65 60,90 75,115 110,110 130,80 90,45";

  return (
    <svg viewBox="0 0 280 150" width="100%" style={{ display: 'block' }} aria-label="Hull diagram">
      <defs>
        <marker id="arr-hull" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
          <path d="M0,1 L5,3 L0,5 Z" fill="#f59e0b" />
        </marker>
      </defs>

      {/* Convex hull polygon (result) */}
      <polygon points={hull}
               fill="rgba(96,165,250,0.18)" stroke={D.GEO_STROKE} strokeWidth="1.5"
               strokeDasharray="5 3" opacity="0.7" />

      {/* Individual child shapes */}
      {shapes.map((s, i) => (
        <rect key={i} x={s.x - 6} y={s.y - 6} width={12} height={12}
              fill="rgba(96,165,250,0.3)" stroke={D.GEO_STROKE} strokeWidth="1.2" />
      ))}

      {/* Arrow + label */}
      <text x={160} y={75} fontSize="10" fontFamily="monospace"
            fill="#f59e0b" opacity="0.9">hull()</text>
      <text x={160} y={89} fontSize="9" fontFamily="monospace"
            fill="currentColor" opacity="0.5">wraps all</text>
      <text x={160} y={101} fontSize="9" fontFamily="monospace"
            fill="currentColor" opacity="0.5">children in a</text>
      <text x={160} y={113} fontSize="9" fontFamily="monospace"
            fill="currentColor" opacity="0.5">convex shell</text>

      <text x="8" y="142" fontSize="9" fontFamily="monospace"
            fill="currentColor" opacity="0.4">like a rubber band stretched around all shapes</text>
    </svg>
  );
}
